module.exports = __webpack_public_path__ + "img/kaodian1.726d2912.png";